import React from 'react';
import { connect } from 'react-redux';
import { EligibilityResultsProvider } from "../../../CEF/Providers";
import { getValidKeys, getApplication } from "../../../../store/Selectors";
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import { Content } from "./Content";
import { useRedirect } from "./useRedirect";
import { Layout } from "../../../../components/StudentOnboarding/Layout";
var UnconnectedAdvisorConfirmationPage = function UnconnectedAdvisorConfirmationPage(_ref) {
  var applicationLoaded = _ref.applicationLoaded,
    application = _ref.application,
    validKeys = _ref.validKeys;
  var redirectLocation = useRedirect();
  if (!applicationLoaded || !redirectLocation) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, null);
  }
  var handleOnClick = function handleOnClick() {
    window.location.assign(redirectLocation);
  };
  return /*#__PURE__*/React.createElement(EligibilityResultsProvider, {
    application: application,
    validKeys: validKeys
  }, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Content, {
    handleOnClick: handleOnClick
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  var application = getApplication(state);
  var validKeys = getValidKeys(state);
  return {
    applicationLoaded: state.CefApplication.applicationLoaded,
    application: application,
    validKeys: validKeys
  };
};
var connector = connect(mapStateToProps, null);
var AdvisorConfirmationPageAnon = connector(UnconnectedAdvisorConfirmationPage);
export default AdvisorConfirmationPageAnon;